<div class="container poppins">
  <div class="display-flex justify-content-center poppins titulos">
    <h1 class="poppins rec" translate>
      components.recoveryPassword.Recuperación de
    </h1>
    &nbsp;
    <h1 class="poppins pass" translate>
      components.recoveryPassword.Contraseña
    </h1>
  </div>
  <div class="col-md-6 mt-3 mx-auto" *ngIf="isChecking">
    <div class="text-center col-12" style="padding: 20px 0 30px 0" translate>
      <i class="fa fa-exclamation-circle"></i
      >components.recoveryPassword.Procesando...
    </div>
  </div>
  <div class="col-md-6 mt-3 mx-auto" *ngIf="verified">
    <div class="card-body">
      <form (ngSubmit)="recoverPassword()" [formGroup]="recoverForm" novalidate>
        <div class="form-group">
          <label class="d-block">
            <div class="input-group">
              <input
                aria-describedby="btnGroupAddon"
                id="password-inp"
                class="form-control"
                [type]="showPassword ? 'password' : 'text'"
                formControlName="password"
                autocomplete="current-password"
                placeholder="{{
                  'components.recoveryPassword.Contraseña' | translate
                }}"
                required
              />
              <div class="input-group-append">
                <div
                  class="input-group-text"
                  id="btnGroupAddon"
                  (click)="hidePassword()"
                >
                  <i class="fas fa-eye"></i>
                </div>
              </div>
            </div>
            <span hidden translate>components.recoveryPassword.Contraseña</span>
            <div
              *ngIf="
                recoverForm.controls.password.invalid &&
                (recoverForm.controls.password.dirty ||
                  recoverForm.controls.password.touched)
              "
            >
              <small
                *ngIf="recoverForm.controls.password.errors?.required"
                class="text-danger"
                translate
              >
                components.recoveryPassword.La contraseña es requerida
              </small>
              <small
                *ngIf="recoverForm.controls.password.errors?.pattern"
                class="text-danger"
                translate
              >
                components.recoveryPassword.t1
              </small>
              <small
                *ngIf="recoverForm.controls.password.errors?.maxlength"
                class="text-danger"
                translate
              >
                components.recoveryPassword.La contraseña debe tener mínimo 20
                caracteres
              </small>
            </div>
          </label>
          <!-- COMPROBACION DE CONTRASEÑA-->
          <label class="d-block">
            <input
              id="reenter-password-inp"
              [type]="showPassword ? 'password' : 'text'"
              min="8"
              max="20"
              class="form-control"
              formControlName="reenterPass"
              placeholder="{{ 'Repetir contraseña' | translate }}"
              required
            />
            <span hidden>Repetir contraseña</span>
            <small
              *ngIf="
                recoverForm.controls.reenterPass.touched && !matchPasswords()
              "
              class="text-danger"
              translate
              >components.registro.passwordsDoNotMatch
            </small>
          </label>

          <button
            id="login-btn"
            class="btn btn-primary w-100 login-button"
            type="submit"
            [disabled]="recoverForm.invalid || !matchPasswords() || isLoading"
          >
            <span translate
              >components.recoveryPassword.Reestablecer contraseña</span
            >
            <i
              class="fas fa-circle-o-notch ms-1 fa-spin"
              [hidden]="!isLoading"
            ></i>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<ng-template #RecuperacionExitosa let-modal>
  <div class="container">
    <div class="col-12" style="padding: 20px 0 20px 0">
      <div style="text-align: end">
        <i
          class="fas fa-times"
          (click)="modal.dismiss('Close button click')"
          type="button"
        ></i>
        <div class="text-center" style="padding: 20px 0 20px 0">
          <img
            src="favicon.ico"
            width="30"
            height="30"
            style="margin-right: 2%"
            loading="lazy"
            alt="Inviertis"
          />
          <br /><br />
          <h1 style="font-size: 30px">
            <strong translate>components.oferta.¡Recuperación exitosa!</strong>
            <br />
          </h1>
          <br />
          <h3 translate>components.oferta.Proceda a ingresar al sistema</h3>
          <br />

          <small style="color: #828282; font-size: 14.5px" translate
            >components.oferta.footer1</small
          >
          <a
            [routerLink]="[
              '/' +
                (translateService.currentLang === 'es' ? 'es' : 'en') +
                '/sobre-nosotros/contacto'
            ]"
            (click)="modal.dismiss('Close button click')"
            translate
            >components.oferta.footer4</a
          >
        </div>
      </div>
    </div>
  </div>
</ng-template>
